/* eslint-disable import/prefer-default-export */
import { Dimensions } from 'react-native';
import Game from '../Domain/Models/API/Game';
import Session from '../Domain/Models/API/Session';
import LeaderboardEntry from '../Domain/Models/LeaderboardEntry';
import ShareType from '../Domain/Types/ShareType';

/**
 * The default booking url when the discount is 0%.
 */
export const DefaultBookingUrl = 'https://www.urbanplayground.co.uk/attractions/manchester/the-cube';
export const UrbanPlaygroundHome = 'https://www.urbanplayground.co.uk/';

/**
 * Large booking token key
 */
export const LargeBookingTokenKey = 'largebooking';

const getBlankCubeGame = (cubeName: string): Game => (
  {
    gameName: cubeName,
    leftTeamScore: 0,
    rightTeamScore: 0,
    leftTeamCheatsUsed: {
      livesUsed: 0,
      swapped: false,
      simplify: false,
    },
    rightTeamCheatsUsed: {
      livesUsed: 0,
      swapped: false,
      simplify: true,
    },
  }
);

/**
 * Empty Session.
 */
export const EmptySession: Session = {
  takeAwaySessionDate: Date.now().toLocaleString(),
  teams: [{
    teamId: 1,
    name: 'Team One',
    score: 0,
    players: [
      {
        playerId: '11',
        gameTagName: 'Player_11',
        firstname: '',
        lastName: '',
        waiverSigned: true,
      },
      {
        playerId: '12',
        gameTagName: 'Player_12',
        firstname: '',
        lastName: '',
        waiverSigned: true,
      }],
  },
  {
    teamId: 2,
    name: 'Team Two',
    score: 0,
    players: [
      {
        playerId: '21',
        gameTagName: 'Player_21',
        firstname: '',
        lastName: '',
        waiverSigned: true,
      },
      {
        playerId: '22',
        gameTagName: 'Player_22',
        firstname: '',
        lastName: '',
        waiverSigned: true,
      }],
  }],
  games: [
    getBlankCubeGame('Cube_1'),
    getBlankCubeGame('Cube_2'),
    getBlankCubeGame('Cube_3'),
    getBlankCubeGame('Cube_4'),
    getBlankCubeGame('Cube_5'),
    getBlankCubeGame('Cube_6'),
    getBlankCubeGame('Cube_7'),
  ],
  rightDailyLeaderboard: [],
  leftDailyLeaderboard: [],
  rightGlobalLeaderboard: [],
  leftGlobalLeaderboard: [],
};

/**
 * The Screen Dimensions.
 */
export const { width: SCREEN_WIDTH, height: SCREEN_HEIGHT } = Dimensions.get('screen');

/**
 * The Window Dimensions.
 */
export const { width: WINDOW_WIDTH, height: WINDOW_HEIGHT } = Dimensions.get('window');

/**
 * Collection of share type queries.
 */
export const ShareQueries = [
  {
    shareType: ShareType.Facebook,
    query: 'https://www.facebook.com/sharer/sharer.php?&u=',
  },
  {
    shareType: ShareType.Twitter,
    query: 'https://twitter.com/intent/tweet?text=',
  },
  {
    shareType: ShareType.Email,
    query: 'mailto:?subject=&body=',
  },
  {
    shareType: ShareType.WhatsApp,
    query: 'https://api.whatsapp.com/send?text=',
  },
];

/**
 * Returns the query string.
 * @param shareType The share type.
 * @returns The query string.
 */
export const GetFullSocialShareQuery = (shareType: ShareType, queryParameters: string): string =>
{
  const query = ShareQueries.find((x) => x.shareType === shareType);
  return query === undefined ? '' : `${query.query}${queryParameters}`;
};

/**
 * Sample Team 1 leaderboard.
 */
export const SampleLeftLeaderboard: LeaderboardEntry[] = [
  {
    position: 1,
    name: 'JINDY',
    score: '3250',
    isTeam: true,
  },
  {
    position: 2,
    name: 'Testing Team',
    score: '9080',
    isTeam: false,
  },
  {
    position: 3,
    name: 'Jonas',
    score: '2750',
    isTeam: true,
  },
  {
    position: 4,
    name: 'Testing Team',
    score: '4697',
    isTeam: false,
  },
  {
    position: 5,
    name: 'Testing Team',
    score: '1585',
    isTeam: false,
  },
];

/**
 * Sample Team 2 leaderboard.
 */
export const SampleRightLeaderboard: LeaderboardEntry[] = [
  {
    position: 20,
    name: 'JINDY',
    score: '3250',
    isTeam: true,
  },
  {
    position: 21,
    name: 'Testing Team',
    score: '9080',
    isTeam: false,
  },
  {
    position: 22,
    name: 'JORVIN',
    score: '2750',
    isTeam: true,
  },
  {
    position: 23,
    name: 'Testing Team',
    score: '4697',
    isTeam: false,
  },
  {
    position: 24,
    name: 'Testing Team',
    score: '1585',
    isTeam: false,
  },
];
